<div class="package d-flex flex-column align-items-center v-scrollbar" atlWindowInnerHeight>
  <ng-container *ngIf="packageData?.packages?.length;">
    <div *ngIf="activePackage as package"
      class="package__item"
      [ngClass]="{ package__selected: package.selected }"
    >
      <div class="d-flex h-100 flex-column left-block">
        <div class="left-block--content">
          
          <ng-container *ngIf="!productDetails; else productDetailsBlock">
            <div class="package__info-text" [class.invisible]="resettingProduct">

              <h3 #packageNameRef class="lh-32 fw-500 fz-24 mb-8 ellipsis"
                  [ngbTooltip]="package.name"
                  [disableTooltip]="package.name?.length < packageNameLimit"
                  container="body"
                  triggers="hover touchstart"
                >
                {{ package.name }}
              </h3>

              <div *ngIf="!resettingProduct && activePackage?.description as desc">
                <atl-read-more
                  [content]="desc"
                  [limit]="isMobileView ? 40 : 80"
                  [completeWords]="false"
                  (toggledText)="updateToggleState($event)"
                  class="text-black-810 mb-12 lh-24"
              >
                </atl-read-more>
              </div>
            </div>
            <span *ngIf="expandedDescription" class="border-separator">

            </span>
            <ng-container *ngIf="!expandedDescription">
              <div [class.invisible]="resettingProduct"
                *ngIf="package.images.length; else imagePlaceholder"
                class="package__content d-flex justify-content-center align-items-center"
              >
                <atl-image-slider *ngIf="!resettingProduct"
                  (openPreview)="onPreviewImage($event, package.images)"
                  [displayW500Image]="true" [images]="package.images" 
                  [config]="imageSliderOptions">
                </atl-image-slider>
              </div>
            </ng-container>
  
            <div [class.invisible]="resettingProduct" class="package__content package__content--right d-flex flex-column">
              <div class="package__category-wrapper d-flex h-scrollbar">
                <ng-container *ngFor="let category of package.categories; let i = index">
                  <p
                    (click)="selectCategory(category.id, package.categories)"
                    [ngClass]="{ 'package__category-item--selected': category.selected }"
                    class="fz-16 lh-24 mr-24 package__category-item fw-500"
                  >
                    {{ category.name }}
                  </p>
                </ng-container>
              </div>
              <div class="v-scrollbar overlay-y package__products-scroll">
                <div class="package__category-products">
                  <ng-container *ngFor="let category of package.categories">
                    <ng-container *ngIf="category.selected">
                      <ng-container *ngFor="let product of category.products; let first = first; let last = last">
                        <div class="position-relative">
                          <atl-card-container
                            (click)="openProductDetails(product, category.id)"
                            class="cursor-pointer"
                            [ngClass]="{
                              'border-bottom': !last,
                              last: last,
                              first: first
                            }"
                          >
                            <ng-container ngProjectAs="cc-icon">
                              <div *ngIf="product.addedToWishlist" class="options-electro__checked-wrapper">
                                <img class="options-electro__checked" src="/assets/checked-circle.svg" alt="Icon" />
                              </div>
                            </ng-container>
                            <ng-container ngProjectAs="cc-info">
                              <div class="package__icon mr-16 br-8 d-flex justify-content-center align-items-center">
                                <img width="48"  height="48" [src]="product.preview" alt="icon" class="br-8" />
                              </div>
                            </ng-container>
                            <ng-container ngProjectAs="occ-control">
                              <div class="tablet-view">
                                <p class="fz-16 lh-24 fw-500 d-block white-space-nowrap"
                                [ngbTooltip]="product.title"
                                [disableTooltip]="product.title.length < maxProductLen"
                                container="body"
                                triggers="hover touchstart"
                                 >{{ product.title | truncate: isMobileView ? mobileMaxProductLen :  maxProductLen }}</p>
                                <ng-container *ngIf="!product.isPlaceholder">
                                  <div class="d-inline-flex align-items-center">
                                    <span class="fz-16 lh-24 mr-4 white-space-nowrap text-black-810 ellipsis">{{ product.productTypeName }} 
                                      <ng-container *ngIf="product.priceType === priceType.Fixed">
                                        ·  {{product.quantity}} {{'Shared.Entity.Items_included' | translate}}
                                      </ng-container>
                                      <ng-container *ngIf="product.priceType === priceType.SquareMeter">
                                        ·  {{product.areaSize}} <span class="lowercase">{{'Entity.Sqm' | translate}}</span>
                                      </ng-container>  
                                      <ng-container *ngIf="product.priceType === priceType.RunningMeter">
                                        ·  {{product.runLength}} M
                                      </ng-container> 
                                    </span>
                                    <span
                                      *ngIf="!packageData.optionDesignLine"
                                      class="fz-16 lh-24 white-space-nowrap ellipsis"
                                    >
                           
                                      •
                                      {{
                                        product.standard
                                          ? (('Shared.Title.Included' | translate) + ' · ' +  (product.price | customDecimal) + ',-')
                                          : product.price !== 0
                                            ? ('Shared.Entity.Option' | translate) +
                                              ' · ' +
                                              (product.price | customDecimal) +
                                              ',-'
                                            : ('Title.Cost_free_option' | translate) + ' · 0,-'
                                      }}</span
                                    >
                                  </div>
                                </ng-container>
                              </div>
                            </ng-container>
                         
                          </atl-card-container>
                        </div>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </div>
              </div>
            </div>

          </ng-container>
        </div>

      </div>

      <ng-template #productDetailsBlock> 
         <ng-container *ngIf="productDetails as product">
          <ng-container *ngIf="product.imagesAttributes.length; else imagePlaceholder">
            <atl-image-slider 
              #atlImageSliderComponent
              class="images-slider"
              [images]="product.imagesAttributes"
              [config]="imageSliderOptions"
              [displayW500Image]="true"
              (afterInitSwiper)="afterInitSwiperHandler()"
              (openPreview)="onPreviewImage($event, product.imagesAttributes)"
            >
            </atl-image-slider>
          </ng-container>

          <div class="package__product-details">
            <div class="package__product-details--content v-scrollbar">
              <h3 class="fz-24 fw-500 lh-32">{{product.title}}</h3>
              <p class="text-black-810 fz-16 lh-24"> 
                <span *ngIf="product.productTypeName" >{{product.productTypeName}} </span>
                <span *ngIf="product.productProducer"> · {{product.productProducer.name}}</span> 
                <ng-container *ngIf="product.priceType === priceType.Fixed">
                  ·  {{product.quantity}} {{'Shared.Entity.Items_included' | translate}}
                </ng-container>
                <ng-container *ngIf="product.priceType === priceType.SquareMeter">
                  ·  {{product.areaSize}} <span class="lowercase">{{'Entity.Sqm' | translate}}</span>
                </ng-container>  
                <ng-container *ngIf="product.priceType === priceType.RunningMeter">
                  ·  {{product.runLength}} M
                </ng-container> 
              </p>
              <p class="mt-8 fz-16 lh-24">
                <ng-container *ngIf="product.standard; else notStandard">
                  {{ 'Shared.Title.Included' | translate }}<span *ngIf="showPrices"> · {{ product.price | customDecimal }},-</span>
                </ng-container>
                <ng-template #notStandard>
                  <ng-container *ngIf="product.price !== 0; else freeOption">
                    {{ 'Shared.Entity.Option' | translate }} <span *ngIf="showPrices"> · {{ product.price | customDecimal }},-</span>
                  </ng-container>
                  <ng-template #freeOption>
                    {{ 'Title.Cost_free_option' | translate }}<span> · 0,-</span>
                  </ng-template>
                </ng-template>
              </p>
      
              <atl-shadow-dom-content class="mt-16 fz-16 lh-24">
                <span [innerHTML]="product.description || '' | removeNbsp | safeHtml"></span>
              </atl-shadow-dom-content>
      
              <div class="mt-24 d-flex flex-wrap" *ngIf="product.fileResourcesAttributes.length">
                <atl-newest-document-card
                  class="mr-8 mt-8"
                  *ngFor="let document of product.fileResourcesAttributes"
                  (click)="onPreviewDocument(document)"
                  [fileName]="document.name | truncate: 20"
                  [fileSize]="document.fileSize"
                  [fileType]="document.fileExtension"
                  [downloadLink]="document.fileName?.downloadUrl"
                  [hasRemove]="false"
                >
                </atl-newest-document-card>
              </div>
            </div>

        <div class="package__product-details--footer">
             <button (click)="closeProductDetails()" class="newest-button button-gray button-next w-100 fz-16 ml-24 mr-24">
              <img src="/assets/new-arrow-left.svg" alt="Icon" class="mr-8">
                  {{'Button.Back' | translate}}
             </button>
        </div>
          </div>

         </ng-container>
      </ng-template>


       <div class="w-50 d-flex align-items-center">
         <div class="package__right-block">
           <h3 class="fz-24 fw-500 lh-32">
             {{ !packageData.optionDesignLine ? ('Shared.Button.Select_package' | translate) : ('Title.select_design_line' | translate) }}
           </h3>
           <p class="mt-4 fz-16 lh-24 text-black-810">
             {{
               !packageData.optionDesignLine
                 ? ('Description.Packages' | translate)
                 : ('Description.Design_lines' | translate)
             }}
           </p>
           
           <div class="package-wrapper mt-24 v-scrollbar">
             <ng-container *ngFor="let package of packageData.packages; let i = index; let last = last;">
               <div
                 class="product-card"
                 [ngClass]="{
                   'active': activePackage?.id === package.id,
                   'first': i === 0,
                   'last': last
                 }"
                 (click)="selectPackage(package)"
               >
                 <div class="package-content ellipsis">
                   <div class="image-wrapper">
                     <img
                       [src]="package.images?.length ? package.images[0].fileName.w260.url : '/assets/external-product-icon.svg'"
                       alt="Preview"
                     />
                   </div>
                   <div class="text-content gl-ellipsis-table-wr">
                     <p class="package-name gl-ellipsis-table-item" #packageNameRef
                      [ngbTooltip]="package.name"
                      [disableTooltip]="packageNameRef.offsetWidth >= packageNameRef.scrollWidth"
                      container="body"
                      triggers="hover touchstart"
                      >{{ package.name }}</p>
                     <p *ngIf="showPrices" class="package-price">{{ 'Entity.Price' | translate}}: {{ package.totalPrice | customDecimal }},-</p>
                   </div>
                 </div>
               </div>
             </ng-container>
           </div>
           
   
           <div class="d-inline-flex align-items-center mt-24 package__footer-block">
             <button
               *ngIf="!packageData.optionDesignLine || packageData.optionDesignLineProducts"
               [disabled]="isGuest"
               [class.pointer-events-none]="isGuest"
               class="newest-button button-gray details-button mr-16"
               (click)="packageSelectionHandler(activePackage)"
           >
             {{ 'Title.Make_own_choice' | translate }}
           </button>
   
             <button

               (click)="confirmSelectPackage(activePackage)"
               class="global-button global-button--h32 newest-button"
             >
             <ng-container *ngIf="!packageData?.optionDesignLineProducts; else completeOptionsDesignLineText">
               {{
                 !packageData.optionDesignLine
                   ? ('Title.Choose_and_sign' | translate)
                   : !package.selected
                     ? ('Title.select_design_line' | translate)
                     : ('Title.Selected_design_line' | translate)
               }}
             </ng-container>
             <ng-template #completeOptionsDesignLineText>
                 {{!activePackage?.selected ? ('Shared.Title.Continue_with_design_line' | translate) : 'Title.Selected_design_line' | translate}}
             </ng-template>
             </button>
           </div>
         </div>

       </div>
       
    </div>

  </ng-container>
</div>



<ng-template #noPrice>
  <span>0,-</span>
</ng-template>

<ng-template #imagePlaceholder>
  <div class="package__empty-wrapper" [class.product-details-placeholder]="productDetails">
    <img src="/assets/empty-icon-v3.svg" alt="Image" width="40" height="25">
  </div>
</ng-template>


